import "../components/loader/index";
import { DiscussionShareButtonController } from "../controllers/DiscussionShareButtonController";
import EventReplayVideoController from "../controllers/EventReplayVideoController";
// import EventTimeZoneAlertController from "../controllers/EventTimezoneAlertController";
import { DiscussionType } from "../core/interfaces/Discussion";
import { getPathPosition, waitForNodeInScreen } from "../core/utilities";

const event_video_replay_load = (
  discussionId: string,
  isEditOrCreateMode = false
) => {
  const evrCtrl = new EventReplayVideoController();
  evrCtrl.init({
    container: ".pageTitleContainer",
    discussionId: discussionId,
    isEditOrCreateMode,
  });
};
// sibling: "[class*=-Events-classes-details]",

const discussion_share_button_load = () => {
  const dsbCtrl = new DiscussionShareButtonController();
  dsbCtrl.init("div[class$=-pageHeadingStyles-actions]", DiscussionType.event);
};

// We are not displaying the alert anymore.
// const event_timezone_alert_load = async () => {
//   const etzAlertCtrl = new EventTimeZoneAlertController();
//   etzAlertCtrl.init();
// };

/**
 * Recipe
 */
const event_recipe = () => {
  console.info("Event summary recipe");

  const discussionId = getPathPosition(3).split("-")[0];
  const isEditOrCreateMode = ["edit", "new"].includes(
    getPathPosition(-1).toLowerCase()
  );

  // Wait for React component to load
  waitForNodeInScreen(".mainColumn").then(() => {
    event_video_replay_load(discussionId, isEditOrCreateMode);
    discussion_share_button_load();
    // We are not displaying the alert anymore.
    // event_timezone_alert_load();
  });
};

event_recipe();
